// apps/client/src/game/testFinders/museum.ts (M2-T10) — inside: 'curator' (a free tile centre in front of the lectern within
// interactRange of Professor Reed; `__wt.walkTo` floors to a tile and stops at its centre, so the point is a tile centre) and
// 'museumExit' (the inside door tile); outdoors: 'museumDoor' (sites.museumDoor's centre). Used by M2-T12's e2e.
// v1 round 4: 'museumFull' (the curator's spot) once the museum on screen is a finished collection, every fossil and fish of the
// catalog donated and each one built, baked and in the scene (no ghost bone left); null until then.
import { tuning, type CatalogId } from '@whiskerton/content';
import { hallComplete } from '@whiskerton/shared/rules/museum';
import { useGame } from '../../state/store';
import { curatorStandPoint } from '../../world/spaces/museum';
import type { Game } from '../game';
import type { TestFinder } from '../testHooks';

function museumFull(game: Game): { id: string; x: number; y: number } | null {
  const s = useGame.getState(), m = s.museumState, scene = game.scenes.current?.scene;
  if (s.space !== 'museum' || !m || !scene) return null;
  const fossils = new Set<CatalogId>(m.fossils.map((e) => e.catalogId)), fish = new Set<CatalogId>(m.fish.map((e) => e.catalogId));
  if (!hallComplete('fossil', fossils) || !hallComplete('fish', fish)) return null;
  const shown = { part: new Set<string>(), fish: new Set<string>(), ghosts: 0 };
  scene.traverse((o) => {
    if (o.name.startsWith('part:')) shown.part.add(o.name.slice(5));
    else if (o.name.startsWith('fish:')) shown.fish.add(o.name.slice(5));
    else if (o.name.startsWith('placeholder:')) shown.ghosts++;
  });
  const all = shown.ghosts === 0 && [...fossils].every((id) => shown.part.has(id)) && [...fish].every((id) => shown.fish.has(id));
  return all ? { id: 'museumFull', ...curatorStandPoint() } : null;
}

export const finders: readonly TestFinder[] = [
  { kind: 'curator', find: () => ({ id: 'curator', ...curatorStandPoint() }) },   // standing spot in front of the lectern
  { kind: 'museumDoor', find: () => { const t = useGame.getState().map?.sites.museumDoor; return t ? { id: 'museumDoor', x: t.x + 0.5, y: t.y + 0.5 } : null; } },
  { kind: 'museumFull', find: museumFull },
  { kind: 'museumExit', find: () => ({ id: 'exit', x: tuning.spaces.museum.door[0] + 0.5, y: tuning.spaces.museum.door[1] + 0.5 }) },   // inside, the door tile
];
